<template>
    <table cellspacing="0" cellpadding="0" class="advance-print-table">
        <thead>
            <tr>
                <th class="left"></th>
                <th class="right">
                    {{ `實際${type === "invoice" ? "收入" : "支出"}` }}
                </th>
                <th class="right">
                    {{ type === "invoice" ? "非專案待開立發票" : "請款待付款" }}
                </th>
                <th v-if="type === 'invoice'" class="right">專案進行中未開立分期</th>
                <th class="right">
                    {{ type === "invoice" ? "預估新案(未來)" : "預估請款支出金額" }}
                </th>
                <th class="right">
                    {{ `預估年度總${type === "invoice" ? "收入" : "支出"}` }}
                </th>
                <th class="right">
                    {{ `佔總${type === "invoice" ? "收入" : "支出"}` }}
                </th>
            </tr>
        </thead>
        <tbody>
            <template v-for="(item, i) in data">
                <tr :key="i" class="group-row">
                    <td class="left">
                        {{ item.iteM_NAM }}
                    </td>
                    <td class="right">
                        <money v-if="!item.custom" :v="item.actuallyAmount" round />
                    </td>
                    <td class="right">
                        <money v-if="!item.custom" :v="item.nonProjectAmount" round />
                    </td>
                    <td v-if="type === 'invoice'" class="right">
                        <money v-if="!item.custom" :v="item.projectAmount" round />
                    </td>
                    <td class="right">
                        <money :v="item.futureAmt" round />
                    </td>
                    <td class="right">
                        <money :v="getTotalAmt(item)" round />
                    </td>
                    <td class="right">
                        {{ getPercentage(getTotalAmt(item), totalAmt) }}
                        %
                    </td>
                </tr>
            </template>
        </tbody>
        <tfoot>
            <tr>
                <td class="left">總計</td>
                <td class="right">
                    <Money :v="actuallyAmount" round />
                </td>
                <td class="right">
                    <div class="total">
                        <span>總額：</span>
                        <Money :v="estimatedAmount" round />
                    </div>
                    <div class="remain">
                        <span>未分配差額：</span>
                        <Money :v="nonDistributedNonProjectAmt" round />
                    </div>
                </td>
                <td v-if="type === 'invoice'" class="right">
                    <div class="total">
                        <span>總額：</span>
                        <Money :v="estimatedProjectAmount" round />
                    </div>
                    <div class="remain">
                        <span>未分配差額：</span>
                        <Money :v="nonDistributedProjectAmt" round />
                    </div>
                </td>
                <td class="right">
                    <Money :v="futureAmount" round />
                </td>
                <td class="right">
                    <Money :v="totalAmt" round />
                </td>
                <td class="right">100 %</td>
            </tr>
        </tfoot>
    </table>
</template>

<script>
import AdvanceMixins from './AdvanceMixins';

export default {
    mixins: [AdvanceMixins],
};
</script>

<style lang="scss" scoped>
.advance-print-table {
    margin-top: 20px;
    width: 100%;
    line-height: 130%;
    font-size: 9pt;

    td {
        padding: 0;
        .money {
            font-weight: normal;
        }
    }

    th.left,
    td.left {
        text-align: left;
    }

    th.right,
    td.right {
        text-align: right;
    }

    tr.group-row td {
        border-top: 1px solid #000;
    }

    tfoot td {
        border-top: 2px solid #333;
        padding-top: 5px;
        vertical-align: top;
    }
}
</style>
